export default __webpack_public_path__ + "static/channel-399c726eae53720a204bef03086b2594.svg";